
import {Err} from "./err.js"

export class TokenErr extends Err {}

